import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { getQuery, firestore } from "firebase_config";
import { Tables } from "constants/index";

function GetUsersComponent({ currentUser, records, setRecords, setLoading }) {
  const [filters, setFilters] = useState({
    email: "",
    name: "",
    clinicId: "",
    doctorId: "",
  });
  const history = useHistory();

  const reloadRecords = async () => {
    const req = await getQuery(
      firestore
        .collection(Tables.DC_PUBLIC_PROFILE)
        .orderBy("updatedAt", "desc")
        .get()
    );
    return req.sort((a, b) => b.updatedAt - a.updatedAt);
  };

  const searchRecords = async () => {
    setLoading(true);
    let filteredRecords = await reloadRecords();
    if (filters.clinicId) {
      filteredRecords = filteredRecords.filter(
        (req) => req.id === filters.clinicId.trim()
      );
    }
    if (filters.doctorId) {
      filteredRecords = filteredRecords.filter(
        (req) => req.userId === filters.doctorId.trim()
      );
    }
    if (filters.email) {
      filteredRecords = filteredRecords.filter(
        (req) => req.email === filters.email?.toLowerCase().trim()
      );
    }
    if (filters.name) {
      filteredRecords = filteredRecords.filter((req) =>
        req.name.toLowerCase().includes(filters.name?.toLowerCase().trim())
      );
    }
    setRecords(filteredRecords);
    setLoading(false);
  };

  const handleChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const cancelSearch = () => {
    history.goBack();
  };

  return (
    <div className="">
      <h3>Get Clinic Details</h3>
      <div className="card px-3 pb-4 my-3">
        <div className="row mt-4">
          <div className="col-12 col-sm-6 my-2">
            <label>Enter Clinic ID</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Clinic ID"
              value={filters.clinicId}
              onChange={(e) => handleChange("clinicId", e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-6 my-2">
            <label>Enter Doctor ID</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Doctor ID"
              value={filters.doctorId}
              onChange={(e) => handleChange("doctorId", e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-6 my-2">
            <label>Enter email</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter Email"
              value={filters.email}
              onChange={(e) => handleChange("email", e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-6 my-2">
            <label>Enter name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Name"
              value={filters.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </div>
        </div>
        <div className="d-flex flex-row mt-2">
          <div className="btn btn-violet btn-sm" onClick={searchRecords}>
            Search
          </div>
          <div
            className="btn btn-outline-danger btn-sm ml-2"
            onClick={cancelSearch}
          >
            Cancel
          </div>
        </div>
      </div>
    </div>
  );
}

export default GetUsersComponent;
